export const isDevelopmentEnv = (env) => env?.isHostEnvironmentDevelopment

export const isTestEnv = (env) =>
    env?.environmentName?.toLowerCase() === 'eid-test'
